/**
 * WARNING: DO NOT EDIT
 * This file is auto-generated and updated by codegen
 */
import { baseActions } from "document-model";
import { subgraphModuleBaseOperationsActions } from "./gen/creators.js";

/** Actions for the SubgraphModule document model */

export const actions = {
  ...baseActions,
  ...subgraphModuleBaseOperationsActions,
};
